// extracted by mini-css-extract-plugin
export default {"supplierslistmain":"EmissionsDetail_supplierslistmain__aB+xK","supplierslisttablewrapper":"EmissionsDetail_supplierslisttablewrapper__hhhVa"};